export const register = {
    title: 'ลงทะเบียน',
    storeId: {
        name: 'รหัสร้านค้า',
        placeholder: '',
        required: 'กรุณาระบุรหัสร้านค้า',
        too_short: '',
        invalid: '',
    },
    storeName: {
        name: 'ชื่อร้านค้า',
        placeholder: '',
        required: 'กรุณาระบุชื่อร้านค้า',
        too_short: '',
        invalid: '',
    },
    firstname: {
        name: 'ชื่อจริง',
        placeholder: '',
        required: 'กรุณาระบุชื่อจริง',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: '',
        required: 'กรุณาระบุนามสกุล',
        too_short: '',
        invalid: '',
    },
    mobileNumber: {
        name: 'เบอร์โทรศัพท์ (มือถือ)',
        placeholder: '',
        required: 'กรุณาระบุเบอร์โทรศัพท์ (มือถือ)',
        too_short: '',
        invalid: 'รูปแบบหมายเลขโทรศัพท์มือถือไม่ถูกต้อง',
    },
    email: {
        name: 'อีเมล์',
        placeholder: '',
        required: '',
        too_short: '',
        invalid: 'รูปแบบอีเมลไม่ถูกต้อง',
    },
    username: {
        name: 'ชื่อเข้าใช้งาน',
        placeholder: '',
        required: 'กรุณาระบุชื่อเข้าใช้งาน',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'รหัสผ่าน',
        placeholder: '',
        required: 'กรุณาระบุรหัสผ่านเป็นตัวอักษร (a-z, A-Z)หรือตัวเลข (0-9) อย่างน้อย 8 ตัวอักษร',
        too_short: 'กรุณาระบุรหัสผ่านเป็นตัวอักษร (a-z, A-Z)หรือตัวเลข (0-9) อย่างน้อย 8 ตัวอักษร',
        invalid: 'รูปแบบการตั้งรหัสผ่านไม่ถูกต้อง',
    },
    confirmPassword: {
        name: 'กรอกรหัสผ่าน (อีกครั้ง)',
        placeholder: '',
        required: 'กรุณาระบุรหัสผ่านนตัวอักษร (a-z, A-Z)หรือตัวเลข (0-9) อย่างน้อย 8 ตัวอักษร',
        too_short: 'กรุณาระบุรหัสผ่านนตัวอักษร (a-z, A-Z)หรือตัวเลข (0-9) อย่างน้อย 8 ตัวอักษร',
        invalid: 'รหัสผ่านไม่ตรงกัน',
    },
    storeType_title: 'ประเภทร้านค้า',
    storeType_err : 'กรุณาระบุประเภทร้านค้า อย่างน้อย 1 ประเภท',
    storeType: {
        StoreID: '',
        StoreName: '',
        StoreType: []
    },
    create_new_password: 'สร้างรหัสผ่านใหม่',
    confirm_new_password: {
        title: 'ยืนยัน?',
        msg: 'คุณยืนยันสร้างรหัสผ่านใหม่ใช่หรือไม่?'
    },
    password_not_match: 'รหัสผ่านไม่ตรงกัน',
    change_password: {
        succress: {
            title: 'ทำรายการสำเร็จ!',
            msg: 'รหัสผ่านของคุณได้ทำการเปลี่ยนแปลงเรียบร้ยแล้ว กรุณาใช้รหัสผ่านใหม่สำหรับเข้าสู่ระบบ',
            btn: 'เข้าสู่ระบบ!'
        },
        error_otp: {
            title: 'พบความผิดพลาด!',
            msg: 'ไม่พบข้อมูล'
        }
    },
    btn_register: 'ลงทะเบียน',
    is_own_shop: 'เป็นเจ้าของร้านค้า/มีร้านค้า'
};
